import { render, staticRenderFns } from "./AnnotationImages.vue?vue&type=template&id=06b422c4&scoped=true"
import script from "./AnnotationImages.vue?vue&type=script&lang=js"
export * from "./AnnotationImages.vue?vue&type=script&lang=js"
import style0 from "./AnnotationImages.vue?vue&type=style&index=0&id=06b422c4&prod&scoped=true&lang=css"
import style1 from "./AnnotationImages.vue?vue&type=style&index=1&id=06b422c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b422c4",
  null
  
)

export default component.exports